function hasDisplayCategory(goods, cateId) {
  if (!goods) {
    return false;
  }

  const displayCateIds = Array.isArray(goods.display_cate_ids) && goods.display_cate_ids.length
    ? goods.display_cate_ids
    : [goods.c_cate];
  return displayCateIds.some(id => String(id) === String(cateId));
}

function uniqueGoodsById(goodsList) {
  const seen = new Set();
  return (Array.isArray(goodsList) ? goodsList : []).filter(goods => {
    if (!goods || goods.id === undefined || goods.id === null) {
      return true;
    }
    const key = String(goods.id);
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}

module.exports = {
  hasDisplayCategory,
  uniqueGoodsById,
};
